import * as React from "react"
import {Box} from "@mui/material";
import {capitalize} from "@ui-seeker/utils"

import {HierarchicalTextBlock} from "@components";


export default function AdminProductReviewDetailsDrawerContentTabAttributes({ attributes }) {
    return <Box sx={{ display: 'flex', flexDirection: 'column' }}>
		{Object.entries(attributes || {}).map(([key, value], idx) => <HierarchicalTextBlock
			key={idx}
			title={`${capitalize(key)}: `}
			titleValue={value}
		/>)}

    </Box>
}